/**
 * Created by user on 2020/1/17.
 */

import createServer from './lib/server';

export { createServer }

export default createServer
